<template>
    <div class="ly_elec_wrap">
        <!-- <me-collapes @collapesCb="collapesCb" :treeTitle="title"> -->
        <div :style="`width: ${treeOuterWidth + 40}px`">
            <div style="margin-bottom: 1.2rem;flex: 1">
                <!-- <el-radio-group
                    v-model="selectType"
                    v-for="item in points"
                    :key="item.tree_unit_type_id"
                    @change="toggleTab(item.tree_unit_type_id)"
                    class="leader-style-radio"
                    size="middle"
                >
                    <el-radio-button :label="item.type_name"></el-radio-button>
                </el-radio-group> -->
                <el-form class="leader-style-form" label-width="50px">
                    <el-form-item label="类型">
                        <el-select v-model="selectType" @change="toggleTab">
                            <el-option
                                v-for="item in points"
                                :key="item.tree_unit_type_id"
                                :label="item.type_name"
                                :value="item.tree_unit_type_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <me-tree
                ref="myTree"
                :treeData="treeData"
                :treeLoading="treeLoading"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :defaultCheckKeys="defaultCheckKeys"
                :treeToolBar="treeToolBar"
                @handleTreeNodeClick="handleTreeNodeClick"
                :defaultExpandedKeys="defaultExpandedKeys"
                :isSingle="true"
                @handleStretchClick="handleStretchClick"
            ></me-tree>
        </div>

        <!-- </me-collapes> -->
        <div class="ly_data_wrap" :style="`width:calc(100% - ${treeOuterWidth}px - 40px)`">
            <el-tabs
                v-model="tabVal"
                type="card"
                @tab-click="handleTabClick"
                class="leader-tab"
            >
                <!-- 非瞬时 -->
                <el-tab-pane
                    :label="firstTab"
                    name="first"
                    v-if="
                        (selectObj.is_electricity == 1 ||
                            selectObj.selectTypeId != '0' ) && (selectObj.class_q == 1 || selectObj.selectTypeId != '0')
                    "
                >
                    <common-monitor :pointObj="selectObj"></common-monitor>
                </el-tab-pane>
                <!-- 瞬时 -->
                <el-tab-pane
                    :label="secondTab"
                    name="second"
                    v-if="
                        selectObj.is_kind == 1 &&
                            selectObj.selectTypeId == '0'
                    "
                >
                    <common-instant
                        :id="selectObj.point_id"
                    ></common-instant>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import monitor from "./components/common_monitor.vue";
import instant from "./components/common_instant.vue";
import * as api from "../../../http/Use_electricity_monitor";
import { getTreeUnitTypeTypeList, getTreeUnitListTypes } from "@/http/api";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes,
        "common-monitor": monitor,
        "common-instant": instant
    },
    data() {
        return {
            treeData: [],
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            selectType: "采集点",
            selectTypeId: "",
            points: [],
            defaultCheckKeys: [],
            defaultExpandedKeys: [],
            title: "采集点选择",
            treeLoading: false,
            treeToolBar: false,
            contWidth: false,
            tabVal: "first", //默认电量
            // selectPid: "", //选中的树id
            firstTab: "", // 第一个tab名称
            secondTab: "瞬时量趋势分析", // 第二个tab名称
            selectObj: {
                selectTypeId: "0"
            },
            point_class_id: "",
            width: 'calc(100% - 280px)',
            treeOuterWidth: 280,
        };
    },
    created() {
        // 第一次进入的时候
        this.point_class_id = '1694583017823166464';
        this.selectObj["point_class_id"] = '1694583017823166464';
        this.getTreeUnitTypeTypeList(this.selectObj.point_class_id);
        this.getCommonPointList(this.selectObj.point_class_id);
        this.getPointClassList(this.selectObj.point_class_id);
    },
    watch: {
        $route(route) {
            // 不能删
            this.tabVal = "first";
            this.selectType = "采集点";
            this.selectObj = { selectTypeId: "0" };
            this.selectObj["point_class_id"] = route.params.point_class_id;
            this.point_class_id = route.params.point_class_id;
            this.getTreeUnitTypeTypeList(this.selectObj.point_class_id);
            this.getCommonPointList(route.params.point_class_id);
            this.getPointClassList(route.params.point_class_id);
        }
    },
    methods: {
        toggleTab(type) {
            this.selectTypeId = type;
            this.selectObj = {
                ...this.selectObj,
                selectTypeId: type,
                point_class_id: this.point_class_id
            };
            console.log("this.selectObj: ", this.selectObj);
            if (type == "0") {
                this.getCommonPointList(this.selectObj.point_class_id);
            } else {
                this.getTreeUnitListTypes(type, this.selectObj.point_class_id);
            }
        },
        // 获取部门 区域
        getTreeUnitTypeTypeList(point_class_id) {
            getTreeUnitTypeTypeList({ point_class_id }).then(res => {
                if (res && res.error_code == 0) {
                    this.points = [
                        {
                            tree_unit_type_id: "0", // 采集点
                            type_name: "采集点"
                        }
                    ];
                    if (res.bus_json.length > 0) {
                        this.points.push(...res.bus_json);
                    }
                }
            });
        },
        // 获取部门区域
        getTreeUnitListTypes(tree_unit_type_id, point_class_id) {
            getTreeUnitListTypes({
                tree_unit_type_id,
                point_class_id
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.treeData = res.bus_json;
                    this.transFormerData(this.treeData);
                    this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    // this.nowClick = res.bus_json[0];
                }
            });
        },
        transFormerData(datas) {
            datas.forEach(item => {
                item["point_id"] = item.tree_unit_id;
                item["point_name"] = item.tree_unit_name;
                if (item.childList && item.childList.length > 0) {
                    this.transFormerData(item.childList);
                }
            });
        },
        handleStretchClick(treeOuterWidth) {
            this.treeOuterWidth = treeOuterWidth;
        },
        // 获取类型
        getPointClassList(point_class_id) {
            api.getPointClassList({ point_class_id }).then(res => {
                if (res && res.error_code == 0) {
                    this.firstTab = `${res.bus_json.class_name}分析`;
                }
            });
        },
        //获取采集点
        getCommonPointList(point_class_id) {
            api.getCommonPointList({ point_class_id }).then(res => {
                if (res && res.error_code === "0") {
                    this.treeData = res.bus_json;
                    if (res.bus_json && res.bus_json.length) {
                        let defaultPoint =
                            res.bus_json[0].childList &&
                            res.bus_json[0].childList.length
                                ? res.bus_json[0].childList[0]
                                : res.bus_json[0];
                        this.defaultCheckKeys = this.defaultExpandedKeys = [
                            defaultPoint.point_id
                        ];
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                defaultPoint.point_id
                            );
                            this.$refs.myTree.handleNodeClick(defaultPoint);
                        });
                    }
                }
            });
        },
        handleTreeNodeClick(sth) {
            this.defaultCheckKeys = this.defaultExpandedKeys = [sth.point_id];
            this.selectObj = {
                ...this.selectObj,
                ...sth,
                point_class_id: this.point_class_id
            };
            if (sth.is_kind == 0 || this.selectObj.selectTypeId != "0") {
                this.tabVal = "first";
            } else if (sth.is_electricity == 0) {
                this.tabVal = "second";
            }
        },
        handleTabClick(tab) {
            if (tab.name == "first") {
                // 电量分析
            } else if (tab.name == "second") {
                // 瞬时量分析
            }
        }
    },
};
</script>
<style lang="scss">
.ly_elec_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    padding: 0 40px;
    box-sizing: border-box;

    .ly_data_wrap {
        height: 100%;
       // padding-left: 20px;
        box-sizing: border-box;
    }
}
</style>
